import {
  UPLOADIMAGE,
  CREATEHEADER,
  SAVECAMPAIGNID,
  UPDATEHEADER,
  GETDATAHEADER,
  UPDATEIMAGE,
  UPDATEFOOTER,
  DELETEALL,
  GETPERTICULAR,
  GETFOOTER,
  GETIMAGES,
} from "./actionTypes";
import { Toastify } from "../../services/toastify/toastifyContainer";
import { apicall } from "../../services/api";

//upload Image
export const uploadImage = (image) => async (dispatch) => {
  try {
    const res = await apicall("dash/uploadImage","post", image, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res.status === 201) {
      Toastify({ data: "success", msg: res?.data?.message });
    }
    dispatch({
      type: UPLOADIMAGE,
      payload: res?.data?.data,
    });
    return res?.data?.data;
  } catch (err) {
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};
export const updateImage = (image) => async (dispatch) => {
  try {
    const res = await apicall("dash/updateImage", "post",image, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res.status === 201) {
      Toastify({ data: "success", msg: res?.data?.message });
    }
    const imageData = res?.data || {};
    dispatch({
      type: UPDATEIMAGE,
      payload: imageData?.data,
    });
    return res?.data?.data;
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

// create Header
export const createHeader = (data) => async (dispatch) => {
  try {
    const res = await apicall("dash/createHeader","post", data);
    if (res.status === 201 && res.data.success === true) {
      dispatch({
        type: CREATEHEADER,
        payload: res,
      });
      Toastify({ data: "success", msg: res?.data?.message });
      localStorage.setItem("uiType", res?.data?.data?.ui_type);
      localStorage.setItem("campaignId", res?.data?.data?.campaign_Id);
      localStorage.setItem("campaign_name", res?.data?.data?.campaign_name);
      return res?.data;
    } else if (res.status === 201 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

// create Body
export const createBody = (data) => async (dispatch) => {
  try {
    const res = await apicall("dash/createBody","post", {
      main_banner_desktop: data.main_banner_desktop,
      main_banner_mobile: data.main_banner_mobile,
      main_heading: data.main_heading,
      main_subHeading: data.main_subHeading,
      disclaimer: data.disclaimer,
      campaign_Id: data.campaignId,
      ui_type: data.uiType,
    });

    if (res.status === 201 && res.data.success === true) {
      Toastify({ data: "success", msg: res?.data?.message });
    }


    return res.data?.data;
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

// create Body Plutos home
export const createBodyPlutos = (data) => async (dispatch) => {

  const body= {
    main_right_banner_desktop: data.main_right_banner_desktop,
    main_right_banner_mobile: data.main_right_banner_mobile,
    rechange_heading: data.rechange_heading,
    rechange_subHeading: data.rechange_subHeading,
    recharge_left_banner_desktop: data.recharge_left_banner_desktop,
    recharge_left_banner_mobile: data.recharge_left_banner_mobile,
    recharge_right_banner_desktop: data.recharge_right_banner_desktop,
    recharge_right_banner_mobile: data.recharge_right_banner_mobile,
    exclusive_heading: data.exclusive_heading,
    exclusive_subHeading: data.exclusive_subHeading,
    exclusive_banner_desktop: data.exclusive_banner_desktop,
    exclusive_banner_mobile: data.exclusive_banner_mobile,
    prime_heading: data.prime_heading,
    prime_subHeading: data.prime_subHeading,
    prime_left_banner_desktop: data.prime_left_banner_desktop,
    prime_left_banner_mobile: data.prime_left_banner_mobile,
    prime_right_banner_desktop: data.prime_right_banner_desktop,
    prime_right_banner_mobile: data.prime_right_banner_mobile,
    coins_banner_desktop: data.coins_banner_desktop,
    coins_banner_mobile: data.coins_banner_mobile,
    coins_heading: data.coins_heading,
    coins_subHeading: data.coins_subHeading,
    vouchers_desktop: data.vouchers_desktop,
    vouchers_mobile: data.vouchers_mobile,
    partners_heading: data.partners_heading,
    partners_subHeading: data.partners_subHeading,
    partners: data.partners,
    disclaimer: data.disclaimer,
    campaign_Id: data.campaignId,
    ui_type: data.uiType,
    created_by: data.created_by,
  }

  try {
    const res = await apicall("dash/createBody/plutosHome","post",body);
    if (res.status === 201 && res.data.success === true) {
      Toastify({ data: "success", msg: res?.data?.message });
    }
    return res.data;
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

//create Footer
export const createFooter = (data) => async (dispatch) => {
  try {
    const res = await apicall("dash/createFooter","post", {
      footer_logo: data.footer_logo,
      social_media: data.social_media,
      customer_support: data.customer_support,
      brand_partners: data.brand_partners,
      quick_links: data.quick_links,
      footer_images: data.footer_images,
      bank_partners: data.bank_partners,
      copy_right: data.copy_right,
      campaign_Id: data.campaignId,
      ui_type: data.uiType,
      created_by: data.created_by,
    });
    if (res.status === 201 && res.data.success === true) {
      localStorage.removeItem("campaignId");
      localStorage.removeItem("uiType");
      localStorage.removeItem("campaign_name");
      Toastify({ data: "success", msg: res?.data?.message });
    }
    return res.data;
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

//get perticular data
export const getParticularforupdate = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `dash/getParticularforupdate/${data.id}/${data.name}`,"get"
    );
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: "Data Retrieved Successfully... " });
      
      localStorage.setItem("uiType", res?.data?.data.data?.ui_type);
      localStorage.setItem("campaignId", res?.data?.data?.data?.campaign_Id);
      localStorage.setItem("campaign_type", res?.data?.data?.data?.campaign_type);
      dispatch({
        type: GETDATAHEADER,
        payload: res.data?.data,
      });
      return res.data;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err);
    if (err.response.status === 404 && err?.response?.data?.msg.includes('not found for campaign ID')) {
      Toastify({ data: "error", msg: err?.response?.data?.msg });
      return 
    }
  }
};

//conditionally
export const getParticular = (id) => async (dispatch) => {
  try {
    const res = await apicall(`dash/checkCampaign/${id}`,"get");
    if (res.status === 200) {
      dispatch({
        type: GETPERTICULAR,
        payload: res.data?.data,
      });
      return res.data;
    } else {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log("carch redux", err);
    // if(err.response.status !== 404)  Toastify({ data: "error", msg: err?.response?.data?.message });
    Toastify({ data: "false", msg: err?.response?.data?.message});
    return err.response.data;
  }
};
export const getForFooter = () => async (dispatch) => {
  try {
    const res = await apicall(`dash/getFooter`,"get", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });;
    if (res.status === 200) {
      dispatch({
        type: GETFOOTER,
        payload: res.data?.data,
      });
      return res.data;
    } else {
      Toastify({ data: "error", msg: res?.data?.message });
      return res.data;
    }
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

// save campign Id
export const saveCampaignId = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: SAVECAMPAIGNID,
      payload: data,
    });
    return { success: true };
  } catch (err) {
    console.log(err);
    Toastify({ data: "error", msg: err?.response?.data?.message });
  }
};

//Update for header
export const updateHeader = (data) => async (dispatch) => { 
  try {
    const res = await apicall(`dash/updateHeader/${data.campaignId}`,"patch", {
      left_nav_logo: data.left_nav_logo,
      nav_lists: data.navList,
      nav_right_logo: data.nav_right_logo,
      campaign_Id: data.campaignId,
      ui_type: data.uiType,
      updated_by: data.updated_by,
      share_image: data.share_image,
      seo_description: data.seo_description,
      seo_keywords: data.seo_keywords,
      seo_title: data.seo_title,
      share_description: data.share_description,
      share_title: data.share_title,
      campaign_name: data.campaign_name,
      deleteUrl: [],
      campaign_type: data?.campaign_type,
      seoDone:data?.seoDone,
      favicon:data?.favicon,
      pay_method:data?.pay_method
    });
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: UPDATEHEADER,
        payload: res.data?.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log("error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.msg});
  }
};

//update for body
export const updateBody = (data) => async (dispatch) => {

  try {
    const res = await apicall(`dash/updateBody/external/${data.campaign_Id}`,"patch", data);
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: UPDATEHEADER,
        payload: res.data?.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log(" error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.message});
  }
};
export const updateBodyPlutos = (data) => async (dispatch) => {

  try {
    const res = await apicall(`dash/updateBody/plutosHome/${data.campaign_Id}`,"patch", data);
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: UPDATEHEADER,
        payload: res.data?.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log(" error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.message});
  }
};

//update for footer
export const updateFooter = (data) => async (dispatch) => {
  try {
    const res = await apicall(
      `dash/updateFooter/${data.campaign_Id}`,"patch",
      data
    );
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: UPDATEFOOTER,
        payload: res.data?.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log(" error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.message});
  }
};

//delete all
export const deleteAll = (data, token) => async (dispatch) => {
  try {
    const res = await apicall(`dash/delete/${data}`,"delete", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: DELETEALL, // Corrected action type
        payload: res.data?.data,
      });
      return res.data?.data;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "success", msg: res.data.message });
    }
    return res.data?.data;
  } catch (err) {
    console.log(" error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.message});
  }
};


export const getHeaderImage = () => async (dispatch) => {
  try {
    let token = localStorage.getItem("token")
    const res = await apicall(`dash/headerImages`,"get", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res.status === 200 && res.data.success === true) {
      Toastify({ data: "success", msg: res.data.message });
      dispatch({
        type: GETIMAGES, // Corrected action type
        payload: res.data,
      });
      return res.data;
    } else if (res.status === 200 && res.data.success === false) {
      Toastify({ data: "success", msg: res.data.message });
    }
  } catch (err) {
    console.log(" error = ", err);
    Toastify({ data: "false", msg: err?.response?.data?.message});
  }
};